@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-100">
        <ui-kit-svg class="i-80 c-secondary-yellow-500" name="ic_warning"/>
        <div class="h3-semi-bold c-primary-gray-900 mt-16 text-center">
            {{ 'i18n_af_dialogDeleteSubjectCategoryTitle' | translate }}
        </div>
        <div class="mt-16 t2 c-primary-gray-600 pre-wrap text-center">
            {{ (dialogData.subjectType === SubjectType.PERSON
                ? 'i18n_af_dialogDeleteSubjectCategoryPersonSubtitle'
                : 'i18n_af_dialogDeleteSubjectCategoryOrganizationSubtitle') | translate:{
                category: dialogData.categoryName,
                identificationNumber: dialogData.identificationNumber
            } }}
        </div>
        <div class="mt-24 w-100">
            <af-dictionary-selector dictionaryName="deleted_based"
                                    [control]="form.controls.deletionReason"
                                    [filterDictionaryBy]="deletedBasedFilter"
                                    label="i18n_af_labelReason"
                                    placeholder="i18n_af_placeholderSelectReason"/>
        </div>
        <div class="t5 c-primary-gray-600 mt-24 w-100">
            {{ 'i18n_af_labelDeleteReason' | translate }}
            {{ form.controls.deletionReason.value === DeletedBaseType.OTHER ? '*' : '' }}
        </div>
        <mat-form-field class="w-100 mt-4">
            <textarea matInput
                      [maxlength]="maxDescriptionLength"
                      class="resize-none pt-12 pb-12"
                      [placeholder]="'i18n_af_placeholderDeletionDescription' | translate"
                      formControlName="description"
                      rows="4"></textarea>
            <mat-hint align="end" class="t2 c-primary-gray-600">
                {{ form.controls.description.value?.length || 0 }} / {{ maxDescriptionLength }}
            </mat-hint>
        </mat-form-field>
        <ui-kit-button class="mt-24 w-100"
                       color="accent"
                       [disabled]="form.invalid"
                       (clickListener)="confirm()"
                       [label]="'i18n_af_buttonDeleteCategory' | translate"/>
        <ui-kit-button class="mt-16"
                       type="text"
                       (clickListener)="dialogRef.close()"
                       [label]="'i18n_af_buttonCancel' | translate"/>
    </form>
}
